import React from 'react'
import Img from 'gatsby-image'
import separator from '../../../img/separateur-2.svg'

const Contact = ({attrs, images}) => {
	const image = attrs && attrs.mediaId && images && images.find(({wordpress_id}) => wordpress_id === attrs.mediaId)

	return(
		<section 
			className="block-contact"
			role="region"
			aria-labelledby="contact-title"
			aria-describedby="contact-description"
			aria-label="Informations de contact"
		>
			<div className="block-contact-thumb" data-testid="contact-thumb">
				{image && image.localFile && image.localFile.childImageSharp ? (
					<Img 
						sizes={image.localFile.childImageSharp.sizes}
						alt="Photo de contact"
					/>
				) : null}
			</div>
			<div className="block-contact-person">
				<h3 
					id="contact-title"
					className="block-contact-person-title"
					dangerouslySetInnerHTML={{__html: attrs?.title || 'Contact'}}
				/>
				<div 
					className="block-contact-person-subtitle"
					dangerouslySetInnerHTML={{__html: attrs?.subtitle || ''}}
				/>
				<img src={separator} alt="Séparateur" />
			</div>
			<div 
				id="contact-description"
				className="block-contact-description" 
				dangerouslySetInnerHTML={{__html: attrs?.contactContent || ''}}
			/>
		</section>
	)
}

export default Contact
